import { render, staticRenderFns } from "./ChapterEventRightSideBar.vue?vue&type=template&id=0261bc17&scoped=true&"
import script from "./ChapterEventRightSideBar.vue?vue&type=script&lang=js&"
export * from "./ChapterEventRightSideBar.vue?vue&type=script&lang=js&"
import style0 from "./ChapterEventRightSideBar.vue?vue&type=style&index=0&id=0261bc17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0261bc17",
  null
  
)

export default component.exports